import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
  standalone: true,
  imports: [SHARED_MODULES, NgxChartsModule],
  templateUrl: './modal-display-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalDisplayChartComponent {
  public readonly view: [number, number] = [700, 400];
  public readonly colorScheme = { domain: ['#f97172', '#61a6fb', '#facc16', '#4adf80'] };
  public readonly data = inject(DIALOG_DATA);
  private readonly dialogRef = inject(DialogRef);

  public onClose() {
    this.dialogRef.close();
  }
}
